/* eslint-disable no-console */
import { RiDeleteBinLine, RiHeart3Fill, RiHeart3Line } from "@remixicon/react";
import { IPrompt, promptsService } from "../../../../services/prompts";
import { IconButton, IconsContainer, StyledPromptItem, Title } from "./styled";
import { ConfirmDeleteModal } from "../../ConfirmDeleteModal";
import { useState } from "react";

interface PromptItemProps {
  showEditDeleteButtons: boolean;
  prompt: IPrompt;
  selected: boolean;
  onSelect: (prompt: IPrompt) => void;
  onUpdatePrompt: (updatedPrompt: IPrompt) => void;
  onDeletePrompt: (promptId: number) => void;
}

const PromptItem: React.FC<PromptItemProps> = ({
  showEditDeleteButtons,
  prompt,
  selected,
  onSelect,
  onUpdatePrompt,
  onDeletePrompt,
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const truncateTitle = (title: string, maxLength: number) => {
    if (title.length > maxLength) {
      return title.substring(0, maxLength) + "...";
    }
    return title;
  };

  const likePrompt = async () => {
    try {
      await promptsService.like(prompt.id);
      const updatedPrompt = { ...prompt, user_has_liked: true };
      onUpdatePrompt(updatedPrompt);
    } catch (error) {
      console.error("error", error);
    }
  };

  const unLikePrompt = async () => {
    try {
      await promptsService.unlike(prompt.id);
      const updatedPrompt = { ...prompt, user_has_liked: false };
      onUpdatePrompt(updatedPrompt);
    } catch (error) {
      console.error("error", error);
    }
  };

  const deletePrompt = async () => {
    try {
      await promptsService.remove(prompt.id);
      onDeletePrompt(prompt.id);
    } catch (error) {
      onDeletePrompt(prompt.id);
    }
  };

  return (
    <>
      <ConfirmDeleteModal
        isOpen={openDeleteModal}
        toggle={() => setOpenDeleteModal(false)}
        message="Tem certeza de que deseja excluir este prompt?"
        onConfirm={deletePrompt}
        onCancel={() => setOpenDeleteModal(false)}
      />
      <StyledPromptItem key={prompt.id} selected={selected} onClick={() => onSelect(prompt)}>
        <Title>{truncateTitle(prompt.title, 30)}</Title>
        <IconsContainer>
          {showEditDeleteButtons && (
            <>
              <IconButton onClick={() => setOpenDeleteModal(true)}>
                <RiDeleteBinLine size={15} />
              </IconButton>
              {/* <IconButton>
              <RiPencilLine size={15} />
            </IconButton> */}
            </>
          )}
          {prompt.user_has_liked ? (
            <IconButton onClick={unLikePrompt}>
              <RiHeart3Fill size={15} color="red" />
            </IconButton>
          ) : (
            <IconButton onClick={likePrompt}>
              <RiHeart3Line size={15} />
            </IconButton>
          )}
        </IconsContainer>
      </StyledPromptItem>
    </>
  );
};

export default PromptItem;
